import { render, staticRenderFns } from "./ViewRateDetailButton.vue?vue&type=template&id=4668f3c4&scoped=true"
import script from "./ViewRateDetailButton.vue?vue&type=script&lang=js"
export * from "./ViewRateDetailButton.vue?vue&type=script&lang=js"
import style0 from "./ViewRateDetailButton.vue?vue&type=style&index=0&id=4668f3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668f3c4",
  null
  
)

export default component.exports